import React from 'react';
import createSvgIcon from '../createNewIcon.js';
const ExclamationMarkCircleSolid = createSvgIcon(React.createElement("path", { d: "M12 1.85718C6.48 1.85718 2 6.33718 2 11.8572C2 17.3772 6.48 21.8572 12 21.8572C17.52 21.8572 22 17.3772 22 11.8572C22 6.33718 17.52 1.85718 12 1.85718ZM13 16.8572H11V14.8572H13V16.8572ZM13 12.8572H11V6.85718H13V12.8572Z" }), 'ExclamationMarkCircleSolid');
export default ExclamationMarkCircleSolid;
